<div class="expansion-panel" [ngClass]="{ collapsed: collapsed }">
    <span class="expansion-panel-divider"></span>
    <div class="toggle-arrow" (click)="toggle()"><span class="theme-up"></span></div>
</div>
